// JavaScript code for acf_blocks/testimonials-grid-with-filter component
(($) => {

    "use strict";

    const $component = $('.acf-blocks-testimonials-grid-with-filter');
    if ( !$component.length ) return;

    const $filterBtns    = $component.find('.filter-btn');
    const $cards         = $component.find('[data-industries]');
    const $noResults     = $component.find('.filter-no-results');
    const $pillsWrapper  = $component.find('.filter-pills-wrapper');
    const $scrollBtnRight = $component.find('.filter-scroll-btn-right');
    const $scrollBtnLeft  = $component.find('.filter-scroll-btn-left');
    const pillsWrapper    = $pillsWrapper[0];

    // ── Filter logic ────────────────────────────────────────────────────────

    $filterBtns.on('click', function () {
        const $btn     = $(this);
        const industry = ($btn.data('industry') || '').toString();

        // Update active state
        $filterBtns.removeClass('active');
        $btn.addClass('active');

        // Scroll clicked button into the centre of the pills wrapper
        const btn = $btn[0];
        btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setTimeout( updateScrollBtns, 350 );

        // Show / hide cards
        $cards.each(function () {
            const $card          = $(this);
            const cardIndustries = ($card.data('industries') || '').toString().split(',').filter(Boolean);

            if ( !industry || cardIndustries.includes(industry) ) {
                $card.removeClass('hidden');
            } else {
                $card.addClass('hidden');
            }
        });

        // Toggle no-results message
        const hasVisible = $cards.filter(':not(.hidden)').length > 0;
        $noResults.toggleClass('hidden', hasVisible);
    });

    // ── Scroll arrow logic ───────────────────────────────────────────────────

    if ( !pillsWrapper ) return;

    function updateScrollBtns() {
        const atStart = pillsWrapper.scrollLeft <= 0;
        const atEnd   = pillsWrapper.scrollLeft + pillsWrapper.clientWidth >= pillsWrapper.scrollWidth - 1;

        $scrollBtnLeft.prop( 'disabled', atStart );
        $scrollBtnRight.prop( 'disabled', atEnd );
    }

    $scrollBtnRight.on('click', function () {
        // Find the first pill at least partially hidden to the right
        const wrapperRight = pillsWrapper.getBoundingClientRect().right;
        const pills        = $pillsWrapper.find('.filter-btn').toArray();
        let   targetPill   = null;

        for ( const pill of pills ) {
            if ( pill.getBoundingClientRect().right > wrapperRight - 1 ) {
                targetPill = pill;
                break;
            }
        }

        if ( targetPill ) {
            targetPill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        setTimeout( updateScrollBtns, 350 );
    });

    $scrollBtnLeft.on('click', function () {
        // Find the last pill at least partially hidden to the left
        const wrapperLeft = pillsWrapper.getBoundingClientRect().left;
        const pills       = $pillsWrapper.find('.filter-btn').toArray();
        let   targetPill  = null;

        for ( let i = pills.length - 1; i >= 0; i-- ) {
            if ( pills[i].getBoundingClientRect().left < wrapperLeft + 1 ) {
                targetPill = pills[i];
                break;
            }
        }

        if ( targetPill ) {
            targetPill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        setTimeout( updateScrollBtns, 350 );
    });

    pillsWrapper.addEventListener( 'scroll', updateScrollBtns );
    $( window ).on( 'resize', updateScrollBtns );
    updateScrollBtns();

})(jQuery);